import Product from "../model/product"

export const defaultProducts: Product[] = [
    {
        item:'6 Months',
        months:"6",
        tag: "Best Value",
        perMonth:"$9.99",
        discountText: "compared to the weekly price!",
        perWeek:"$2.70",
        crossedPrice: "$71.99",
        price: "$64.74",
        percentOff: 80,
        productValue: "mutual:subscription:renewable:6month"
    },
    {
        item:'3 Months',
        months:"3",
        perMonth:"$12.99",
        perWeek:"$3.37",
        crossedPrice: "$44.97",
        discountText: "compared to the weekly price!",
        price: "$40.47",
        percentOff: 70,
        productValue: "mutual:subscription:renewable:3month"
    },
    {
        item:'1 Month',
        months:"1",
        perMonth:"$22.49",
        perWeek:"$5.62",
        crossedPrice: "$24.99",
        discountText: "compared to the weekly price!",
        price: "$22.49",
        percentOff: 60,
        productValue: "mutual:subscription:renewable:1month",
    },
    {
        item:'1 Week Student',
        tag: "Student Discount",
        months:"0",
        weeks:"1",
        perMonth:"",
        discountText: "compared to the weekly price!",
        perWeek:"$9.99",
        crossedPrice: "$14.99",
        price: "$9.99",
        percentOff: 30,
        productValue: "mutual:subscription:renewable:1week",
    },
]
